import React from "react";
import { Button } from "@mui/material";
import {
    PublicClientApplication,
    EventType,
} from "@azure/msal-browser";
import { msalConfig } from "../../configs/azureAuthConfig";

function MicrosoftEntraButton({ onSuccess, onError, msClient }) {
    //get initialize msalInstance
    const msalInstance = new PublicClientApplication(msalConfig(msClient));
    msalInstance.initialize();
    
    const activeAccount = msalInstance.getActiveAccount();
    
    if (!activeAccount) {
        // Account selection
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0) {
            msalInstance.setActiveAccount(accounts[0]);
        }
    }
    
    //set the account
    msalInstance.addEventCallback(function (event) {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
            var authenticationResult = event.payload;
            var account = authenticationResult.account;
            msalInstance.setActiveAccount(account);
        }
    });
    
    //enable account storage event
    msalInstance.enableAccountStorageEvents();

    async function microsoftLoginUser() {
        try {
            const test = await msalInstance.loginPopup({
                scopes: ['user.read'],
                prompt: "select_account"
            })
            onSuccess(test)
        } catch (error) {
            onError(error)
        }
    }
        
    return <Button className="btn-principal btn-login-confirm" onClick={microsoftLoginUser} >
        <img src={process.env.PUBLIC_URL + "/Microsoft_logo.svg"} />
        &nbsp;&nbsp;Acceder con Microsoft
    </Button>
}

export default MicrosoftEntraButton